export default __webpack_public_path__ + "static/media/deleteIcon.40f02dd3.svg";